import styled from 'styled-components';
import { Greyscale } from 'themes/rebrand/colours';

export const StyledExchangeSummaryOD = styled.div`
  padding: ${({ bgColor }) => (bgColor ? '8px' : '0')};
  margin-bottom: 8px;
  background-color: ${({ bgColor }) => bgColor || 'transparent'};
  color: ${({ fontColor, bgColor }) => (fontColor ? String(fontColor) : bgColor ? String(Greyscale.White) : 'inherit')};

  p {
    margin: 8px 0;
    color: ${({ fontColor, bgColor }) => (fontColor ? String(fontColor) : bgColor ? String(Greyscale.White) : 'inherit')};
  }

  span {
    color: ${({ fontColor, bgColor }) => (fontColor ? String(fontColor) : bgColor ? String(Greyscale.White) : 'inherit')};
  }

  svg {
    color: ${({ fontColor, bgColor }) => (fontColor ? String(fontColor) : bgColor ? String(Greyscale.White) : 'inherit')};
    stroke: ${({ fontColor, bgColor }) => (fontColor ? String(fontColor) : bgColor ? String(Greyscale.White) : 'currentColor')};
  }
`;
